import React from 'react';

import DisclaimerTag from 'components/ModularBlocks/Disclaimer/styled//DisclaimerTag';
import DisclaimerBody from 'components/ModularBlocks/Disclaimer/styled/DisclaimerBody';
import DisclaimerHeader from 'components/ModularBlocks/Disclaimer/styled/DisclaimerHeader';

import { DisclaimerBlockI } from 'interfaces/content-stack/modular-blocks/DisclaimerTypes';

export interface DisclaimerProps {
  data: {
    reference: Array<DisclaimerBlockI>;
  };
  fontSize?: string | undefined;
}

const Disclaimer: React.FC<DisclaimerProps> = ({ data, fontSize }) => {
  const { reference } = data;
  const { disclaimerType, modularBlocks } = reference?.[0] ?? {};

  return (
    <DisclaimerTag type={disclaimerType}>
      {modularBlocks?.map((block, index) => {
        if (!block.header) {
          return <DisclaimerBody fontSize={fontSize} body={block.body} key={index} />;
        }

        return <DisclaimerHeader header={block.header} key={index} />;
      })}
    </DisclaimerTag>
  );
};

export default React.memo(Disclaimer);
